import ReceiptIcon from '@mui/icons-material/Receipt';
import { Avatar, Chip, Divider, Grid, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { dateformat } from '../../../../helpers';
import { convertirVEF } from '../../../../helpers/ConversionesHelper';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import { getEstatusRecibosColor } from './SelectEstatusRecibos';

const DetallesRecibosComponent = () => {
  const recibosStore = Redux.useSelector((state) => state.recibos);
  const entMonedasStore = Redux.useSelector((state) => state.entMonedas);

  const activo = recibosStore.activo;

  const cambios = {};
  entMonedasStore.all.forEach((item) => {
    if (item.cambio) {
      let total = 0.0;
      if (item.cambio.abrev === 'VEF') {
        total = convertirVEF(item.tasa, activo.total);
      }
      cambios[item.cambio.abrev] = total;
    }
  });

  const titular = (
    <Grid container spacing={1}>
      <Grid item xs={12} md={5}>
        <Typography variant="h6">
          <strong>Representante</strong>
          <Divider sx={{ my: 1 }} />
        </Typography>
        <Typography>
          <strong>Identificación: </strong>
          {activo.familiar?.perfil.tipoDni}-{activo.familiar?.perfil.dni}{' '}
        </Typography>
        <Typography>
          <strong>Nombres y apellidos: </strong>
          {activo.familiar?.perfil.pnombre} {activo.familiar?.perfil.papellido}{' '}
        </Typography>
      </Grid>
      <Grid item xs={12} md={7}>
        <Typography variant="h6">
          <strong>Estudiante</strong>
          <Divider sx={{ my: 1 }} />
        </Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          <Avatar
            alt={activo.matricula.estudiante.usuario.perfil.pnombre}
            src={
              activo.matricula.estudiante.usuario.perfil.avatar
                ? getFilesArchivos(
                    activo.matricula.estudiante.usuario.perfil.avatar,
                  )
                : `static/images/${
                    activo.matricula.estudiante.usuario.perfil.gender
                      ? 'userf.png'
                      : 'userm.png'
                  }`
            }
            sx={{ width: 100, height: 100 }}
          />
          <div>
            <Typography>
              <strong>Identificación: </strong>
              {activo.matricula.estudiante.usuario.perfil.tipoDni}-
              {activo.matricula.estudiante.usuario.perfil.dni}{' '}
            </Typography>
            <Typography>
              <strong>Nombres y apellidos: </strong>
              {activo.matricula.estudiante.usuario.perfil.pnombre}{' '}
              {activo.matricula.estudiante.usuario.perfil.snombre}{' '}
              {activo.matricula.estudiante.usuario.perfil.papellido}{' '}
              {activo.matricula.estudiante.usuario.perfil.sapellido}{' '}
            </Typography>
            <Typography>
              <strong>Nivel académico: </strong>
              {activo.matricula.secciones[0].seccion.nivelAcademico.nombre} (
              {activo.matricula.secciones[0].seccion.nivelAcademico.abrev})
            </Typography>
            <Typography>
              <strong>Sección: </strong>
              {activo.matricula.secciones[0].seccion.nombre}{' '}
              <strong>Turno: </strong>
              {activo.matricula.secciones[0].seccion.turno}{' '}
            </Typography>
          </div>
        </Stack>
      </Grid>
    </Grid>
  );

  return (
    <Grid container spacing={2}>
      <Grid item md={12}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={3}>
            <Typography>
              <strong>Código: </strong>
              {activo.codigo}
            </Typography>
            <Typography>
              <strong>Estatus: </strong>
              <Chip
                label={`${activo.estatus.nombre}`}
                size="small"
                sx={{
                  color: 'white',
                  backgroundColor: getEstatusRecibosColor(activo.estatus.id),
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography>
              <strong>Fecha tope: </strong>
              {dateformat(activo.fechaTope, { standard: true })}
            </Typography>

            <Typography>
              <strong>Fecha de verificación: </strong>
              {activo.fechaVerificado
                ? dateformat(activo.fechaVerificado, { standard: true })
                : '--'}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            {activo.fechaPago && activo.referencia && (
              <Stack direction="row" alignItems="center">
                <Avatar
                  alt={'foto de la referencia'}
                  src={getFilesArchivos(activo.avatar)}
                  sx={{ width: 100, height: 100, mr: 1 }}
                >
                  <ReceiptIcon />
                </Avatar>
                <div>
                  <Typography>
                    <strong>Fecha de pago: </strong>
                    {activo.fechaPago
                      ? dateformat(activo.fechaPago, { standard: true })
                      : '--'}
                  </Typography>
                  <Typography>
                    <strong>Referencia de pago: </strong>
                    {activo.referencia}
                  </Typography>
                  <Typography>
                    <strong>Descripción de pago: </strong>
                    {activo.descPago}
                  </Typography>
                </div>
              </Stack>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid item md={12}>
        {titular}
      </Grid>
      <Grid item md={12}>
        <Typography variant="h6">
          <strong>Conceptos</strong>
        </Typography>
        <Divider />
      </Grid>
      <Grid item md={12}>
        <Grid container spacing={1}>
          <Grid item xs={6} md={6}>
            <strong>Concepto</strong>
          </Grid>
          <Grid item xs={6} md={3}>
            <strong>Costo</strong>
          </Grid>
          <Grid item xs={6} md={3}>
            <strong>Cambio</strong>
          </Grid>
          {activo.conceptosPago.map((el) => {
            const cambios = {};
            entMonedasStore.all.forEach((item) => {
              if (item.cambio) {
                let total = 0.0;
                if (item.cambio.abrev === 'VEF') {
                  total = convertirVEF(item.tasa, el.conceptoPago.costo);
                }
                cambios[item.cambio.abrev] = total;
              }
            });

            return (
              <>
                <Grid item xs={6} md={6}>
                  {el.conceptoPago.nombre}
                  <Divider />
                </Grid>
                <Grid item xs={6} md={3}>
                  $ {el.conceptoPago.costo} USD
                  <Divider />
                </Grid>
                <Grid item xs={6} md={3}>
                  {entMonedasStore.all.map((el, index) => {
                    return (
                      el.cambio && (
                        <Typography
                          key={`cambio-${index}`}
                          sx={{ fontSize: 16 }}
                        >
                          {el.cambio.simbolo} {cambios[el.cambio.abrev]}{' '}
                          {el.cambio.abrev}
                        </Typography>
                      )
                    );
                  })}
                  <Divider />
                </Grid>
              </>
            );
          })}
          <Grid item xs={6} md={6} align="end" paddingRight={4}>
            <strong>Monto a total: </strong>
          </Grid>
          <Grid item xs={6} md={3}>
            <strong>$ {activo.total} USD</strong>
          </Grid>
          <Grid item xs={6} md={3}>
            {entMonedasStore.all.map((el, index) => {
              return (
                el.cambio && (
                  <Typography
                    key={`cambio-${index}`}
                    sx={{ fontSize: 16 }}
                    fontWeight="bold"
                  >
                    {el.cambio.simbolo} {cambios[el.cambio.abrev]}{' '}
                    {el.cambio.abrev}
                  </Typography>
                )
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DetallesRecibosComponent;
